import { Component } from '@angular/core';

@Component({
  selector: 'app-home11',
  templateUrl: './home11.component.html',
  styleUrls: ['./home11.component.scss']
})
export class Home11Component {}
